










































import Vue from 'vue'
import Component from 'vue-class-component'
import { IProduct, IEditProductRequest, IVersion } from '../model/ProductsState'
import { Watch } from 'vue-property-decorator'
import  ProductService  from '../services/ProductsService'

@Component({})
export default class EditProduct extends Vue {
    product: IProduct
    productService: ProductService
    editRequest: IEditProductRequest

    constructor () {
      super()
      this.productService = new ProductService();
      this.product = { id:-1, userId:-1 , name: "", description: "",  releaseDate: new Date(), versions: [] as IVersion[] }
        this.editRequest = {id: this.product.id, name: this.product.name, description: this.product.description}
    }

    get params(){
        return this.$route.params.id;
    }

    mounted(){
        this.productService.getProductById(+this.$route.params.productId).then(prod => {
            this.product = prod
            this.editRequest = {id: this.product.id, name: this.product.name, description: this.product.description,
                buildServerUri: this.product.buildServerUri, buildServerUserName: this.product.buildServerUserName,
                buildServerPassword: this.product.buildServerPassword, buildServerProjectName: this.product.buildServerProjectName,
                buildServerBuildType: this.product.buildServerBuildType}
        })

    }

    submit(){
        this.productService.editProduct(this.editRequest).then(() => {
            this.$router.push(`/product/${this.product.id}`)
        })
    }
}
